import React from 'react'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import './omt.css'

export default () => {
  return (
    <div className="app-landing__omt">
      <p>
        <OutboundLink href="https://rapport-app.leanloop.co.uk/" className="btn">
          Start a Meeting
        </OutboundLink>
      </p>
      <p>Get started today, totally free.</p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/omt.js